// extracted by mini-css-extract-plugin
module.exports = {"root":"ResetPasswordModal_root__P32Wo","headline":"ResetPasswordModal_headline__PSRbX"};